/**
 * AUTO-GENERATED FILE. Do not edit directly.
 * Generated by scripts/generateBlogMapping.js
 * Source: landing/blogs/*.html (meta tags: event-name, event-pattern, blog-title)
 */

const BLOG_MAPPING = {
  "Alchemy of Fusion": {
    "blogUrl": "/blogs/fusion-alembic-2025-07-18.html",
    "blogTitle": "Read about the Fusion dance experience at Alembic",
    "type": "pattern"
  },
  "BAmF - Bay Area micro Fusion": {
    "blogUrl": "/blogs/fusion-bamf-emeryville-2025-08-09.html",
    "blogTitle": "Read about the Bay Area Micro Fusion experience",
    "type": "pattern"
  },
  "Sunday Latin Bootcamp": {
    "blogUrl": "/blogs/salsa-latin-bootcamp-2025-10-05.html",
    "blogTitle": "Read about Sunday Latin Bootcamp with Lorans, Latin Jam",
    "type": "pattern"
  },
  "Sausalito Seahorse Salsa Sunday": {
    "blogUrl": "/blogs/salsa-sausalito-seahorse-2025-10-12.html",
    "blogTitle": "Read about Sausalito Seahorse Salsa Sunday",
    "type": "pattern"
  },
  "SJ Fusion": {
    "blogUrl": "/blogs/sj-fusion-dance-boulevard-2025-08-24.html",
    "blogTitle": "Read about San Jose Fusion at Dance Boulevard",
    "type": "pattern"
  },
  "The Beat w/ Felipe & Ayano": {
    "blogUrl": "/blogs/tango-beat-2025-08-25.html",
    "blogTitle": "Read about Tango at The Beat with Felipe & Ayano",
    "type": "pattern"
  },
  "Milonga Rubia w/ DJ": {
    "blogUrl": "/blogs/tango-milonga-rubia-2025-09-07.html",
    "blogTitle": "Milonga Rubia w/ DJ Ayano — Big Floor, Friendly Regulars, and BYOB",
    "type": "pattern"
  },
  "Tango at Salesforce Park": {
    "blogUrl": "/blogs/tango-salesforce-park-2025-08-17.html",
    "blogTitle": "Read about the free Tango class at Salesforce Park",
    "type": "pattern"
  },
  "Vecher Tango": {
    "blogUrl": "/blogs/tango-vecher-2025-08-30.html",
    "blogTitle": "Read about Vecher Tango",
    "type": "pattern"
  }
};

export const getBlogForEvent = (eventName) => {
  // First try exact match
  if (BLOG_MAPPING[eventName] && BLOG_MAPPING[eventName].type === 'exact') {
    return BLOG_MAPPING[eventName];
  }
  
  // Then try pattern matching
  for (const [pattern, blogInfo] of Object.entries(BLOG_MAPPING)) {
    if (blogInfo.type === 'pattern' && eventName.includes(pattern)) {
      return blogInfo;
    }
  }
  
  return null;
};
export const getEventsWithBlogs = () => Object.keys(BLOG_MAPPING);
export default BLOG_MAPPING;
